export enum JobflexQuery {
  resume = 'resume',
  mypage = 'mypage',
}

export type JobflexQueryType = keyof typeof JobflexQuery;
